const FromArr = [
  {
    title: "发布时间：",
    StartTime: "",
    EndTime: "",
    inputtype: "dateSection",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "发布时间",
    disabled: false,
    widthRight: 240,
    heightRight: 32,
    heightLeft: 32,
    marginLeft: 20,
    marginTop: 18,
    displayVal: "inline-block",
    fontWeightVal: 500,
  },
  {
    modelvalue: "",
    title: "文件名称：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 240,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 10,
    displayVal: "inline-block",
    fontWeightVal: 500,
  },
];
export default FromArr;
